import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import '../Login/styles.css';

import { LoadingIndicator } from '@components';
import { baseADM } from '@services/env-variables';
import { loginADM, getDadosPessoais } from '../../store/user/thunks';
import { HOME } from '../../common/utils/paths';

import { useAuth } from '../Shell';

export const SimularUsuarioPage = () => {
  const paramsURL = useParams();
  const [isADM, setIsADM] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useAuth();
  const matricula = useSelector((state) => state.user.data?.matricula);
  const isLogged = useSelector((state) => state.user.isLogged);
  const ambienteURL = baseADM;

  useEffect(() => {
    if (
      window.location.origin.indexOf(ambienteURL) > -1 &&
      paramsURL?.matricula &&
      paramsURL?.token
    ) {
      setIsADM(true);
      dispatch(
        loginADM({
          matricula: paramsURL.matricula,
          token: paramsURL.token,
        })
      )
        .unwrap()
        .then(() => {
          dispatch(getDadosPessoais());
        })
        .catch(() => {});
    }
  }, [ambienteURL, dispatch, paramsURL]);

  useEffect(() => {
    if (matricula && window.location.origin.indexOf(ambienteURL) > -1) {
      if (isLogged === true) {
        auth.signin(matricula, () => {
          navigate(HOME, { replace: true });
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, isLogged, matricula, navigate]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 col-sm-8 col-md-6 col-lg-5 mx-auto">
          <div className="card">
            <h1 className="d-block text-center text-muted mt-32 ts-20 fw-bold">
              Simulação de usuário
            </h1>
            {isADM ? (
              <LoadingIndicator />
            ) : (
              <div className="justify-content-center ">
                <p className=" text-center ts-18 text-muted mb-32">
                  A simulação de usuário não é permitida nesse site.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
